import React from 'react';
import { BADGE_CONFIGS } from '../data/columnConfig';

const SourceBadge = ({ source }) => {
  if (!source) return null;

  let config = BADGE_CONFIGS.default;
  let sourceLabel = source;
  
  if (source.includes('zillow') && source !== 'zillow-simulated') {
    config = BADGE_CONFIGS.zillow;
    sourceLabel = config.label;
  } else if (source === 'zillow-simulated') {
    config = BADGE_CONFIGS['zillow-simulated'];
    sourceLabel = config.label;
  } else if (source.includes('attom')) {
    if (source === 'attom') {
      config = BADGE_CONFIGS.attom;
      sourceLabel = config.label;
    } else {
      config = BADGE_CONFIGS['zillow-simulated'];
      sourceLabel = config.label;
    }
  } else if (source.includes('redfin')) {
    if (source === 'redfin') {
      config = BADGE_CONFIGS.redfin;
      sourceLabel = config.label;
    } else {
      config = BADGE_CONFIGS['zillow-simulated'];
      sourceLabel = config.label;
    }
  }
  
  return (
    <span className={`ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.color}`}>
      {sourceLabel}
    </span>
  );
};

export default SourceBadge;